import type { FC, ReactNode } from "react";
import { mergeClasses } from "@huub-web/utils";

import type { ChildrenProp, ClassNameProp } from "../../props";
import { Indicator, type IndicatorProps } from "../Indicator/Indicator";
import { Flex } from "../Flex/Flex";
import { Text } from "../Text/Text";
import { containerStyle, titleStyle } from "./USP.css";

export type USPProps = ClassNameProp &
  ChildrenProp & {
    variant?: IndicatorProps["variant"];
    icon?: IndicatorProps["icon"];
    size?: IndicatorProps["size"];
    type?: IndicatorProps["type"];
    title: string;
    body?: ReactNode;
    padding?: boolean;
  };

/**
 * USP component for displaying unique selling points
 * @param props - The component props
 * @returns The rendered USP component
 */
export const USP: FC<USPProps> = ({
  variant: indicatorVariant = "tertiary",
  icon: indicatorIcon = "checkThick",
  size: indicatorSize = "l",
  type: indicatorType = "square",
  title,
  body,
  padding = false,
  children,
  className,
}) => (
  <Flex
    className={mergeClasses(containerStyle({ padding }), className)}
    direction="column"
    gap="s"
  >
    <Flex gap="s" align={body ? "flex-start" : "center"}>
      <Indicator
        variant={indicatorVariant}
        icon={indicatorIcon}
        size={indicatorSize}
        type={indicatorType}
      />
      <Flex direction="column" gap="xs">
        <Text className={titleStyle}>{title}</Text>
        {body && <Text color="currentColor50">{body}</Text>}
      </Flex>
    </Flex>
    {children}
  </Flex>
);
